import { useLicensingCheck } from '../../lib/hooks/useLicensingCheck';
import { MachineMismatchBanner } from './MachineMismatchBanner';

interface LicensingGuardProps {
  productCode: string | undefined;
  productName?: string;
  children: React.ReactNode;
}

/**
 * Wraps product content and blocks access when licensing check is not allowed.
 * Shows MACHINE_MISMATCH banner and blocks deep access when reason is MACHINE_MISMATCH.
 */
export function LicensingGuard({ productCode, productName, children }: LicensingGuardProps) {
  const { data, isLoading, isError, allowed, reason } = useLicensingCheck(productCode);

  if (isLoading || isError || !data) {
    return (
      <div className="flex items-center justify-center p-8 text-muted-foreground">
        {isLoading ? 'Đang kiểm tra bản quyền…' : 'Không thể kiểm tra bản quyền.'}
      </div>
    );
  }

  if (!allowed && reason === 'MACHINE_MISMATCH') {
    return (
      <div className="space-y-4 p-6">
        <MachineMismatchBanner productName={productName} />
        <p className="text-sm text-muted-foreground">
          Truy cập vào nội dung sản phẩm bị chặn trên thiết bị này.
        </p>
      </div>
    );
  }

  if (!allowed) {
    return (
      <div className="space-y-4 p-6">
        <div
          role="alert"
          className="rounded-lg border border-red-500/50 bg-red-500/10 p-4 text-red-800 dark:text-red-200"
        >
          <p className="font-medium">
            Bạn chưa được cấp quyền sử dụng sản phẩm này (lý do: {reason}).
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
